export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
    ],
    room_number: [
        { required: true, message: 'Пожалуйста, введите номера ', trigger: 'blur' },
    ],
};
